import * as Sentry from '@sentry/browser';

export function isSentryEnabled() {
  // the older version of the Sentry SDK we're forced to use does not have the newer `isInitialized/isEnabled` methods
  // available, so we use this instead
  return !!Sentry.getCurrentHub().getClient();
}

export function initializeSentry() {
  let env = 'production';
  if (window.location.hostname.match(/localhost/)) {
    console.log('Skipping Sentry initialization, we\'re in the development region');
    return;
    // to test Sentry in your local env, comment the two lines above and uncomment the line below
    // env = 'development';
  } else if (window.location.hostname.match(/updoxtest|updoxqa|qa\.sharecaretelehealth|updoxperf|localhost/)) {
    env = 'testing';
  }

  console.log('Initializing Sentry for the ' + env + ' region');
  Sentry.init({
    dsn: 'https://19e60318cb27936dc19d6a18c0e94cb1@o4506220010274816.ingest.us.sentry.io/4508780048547840',
    environment: env,
  });
}

export function addUserToSentryScope(user) {
  if (isSentryEnabled()) {
    if (user.id) {
      Sentry.setUser({
        id: user.id,
        username: user.mentionName,
      });
    } else {
      Sentry.captureMessage('We should have an identity here, but we don\'t!', 'error');
    }
  } else {
    Sentry.captureMessage('Skipping Sentry person configuration, no Sentry object (we\'re hopefully in the development region)', 'warn');
  }
}
